import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpInterceptorFn, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { ServerLogTransferService } from '../services/server-log-transfer.service';
import { environment } from '@env/environment';
export class ErrorInterceptor implements HttpInterceptor {
  toast = inject(ToastrService);
  router = inject(Router);
  platformId = inject(PLATFORM_ID);
  isBrowser = isPlatformBrowser(this.platformId);
  isServer = isPlatformServer(this.platformId);
  serverLogger = inject(ServerLogTransferService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: Error | HttpErrorResponse): Observable<never> => {
        if (!(error instanceof HttpErrorResponse) || !error.error?.message) {
          return throwError(() => error);
        }

        const { message } = error.error;
        const { status } = error;

        // Log server-side errors to client side if on Draft environment
        if (this.isServer && environment.baseUrl.includes('draft') && !environment.production) {
           this.serverLogger.log(`API Error [${request.method}] ${request.url}`, {
             status,
             message,
             fullError: error.message || error.statusText
           });
        }

        if (this.isBrowser) {
          this.showToastForError(status, message, error.statusText);
        }

        // Handle specific navigation for 'Domain not found'
        if (status === HttpStatusCode.NotFound && message === 'Domain not found') {
          if (this.isBrowser) {
            this.router.navigate(['/no-domain'], { replaceUrl: true });
          }
          return EMPTY;
        }
        return throwError(() => error);
      })
    );
  }
  
  showToastForError = (status: number, message: string, statusText: string): void => {
    switch (status) {
      case HttpStatusCode.UnprocessableEntity:
        this.toast.error(message, 'Contenuto non corretto');
        return;

      case HttpStatusCode.BadRequest:
      case HttpStatusCode.Unauthorized:
      case HttpStatusCode.InternalServerError:
      case HttpStatusCode.Forbidden:
      case HttpStatusCode.NotFound:
        this.toast.error(message, statusText);
        return;

      default:
        this.toast.error(message ?? 'An error occurred', statusText);
        return;
    }
  };
}

